<template>
    <div class="index-overviews">
        <div
            class="ah-container"
            style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 12px;
            "
        >
            <div class="section-title">營收趨勢</div>
            <el-select v-model="year" size="small" style="width: 150px" @change="updateData">
                <el-option v-for="item in yearList" :key="item" :label="item" :value="item" />
            </el-select>
        </div>
        <overview-panel
            :isLoading="isLoading"
            :year="this.year"
            :monthlyRevenueDatas="overviewData.monthlyRevenueDatas"
            :revenue="overviewData.revenue"
            :revenueInfo="overviewData.revenueInfo"
            :receivableInfo="overviewData.receivableInfo"
            :payableInfo="overviewData.payableInfo"
            :salaryInfo="overviewData.salaryInfo"
            :variableInfo="overviewData.variableInfo"
        >
        </overview-panel>
        <IndexOverviewMiddle ref="IndexOverviewMiddle" :isLoading="isLoading" :year="year" />
        <div class="ah-container" v-if="isAuth('D12')">
            <DepositSummaryCard
                :year="this.year"
                :date="date"
                :isLoading="isLoading"
                :monthlyData="bankData.monthlyBankBalanceInfo"
                :taiwanDepositTotal="taiwanDepositTotal"
                :foreignDepositTotal="foreignDepositTotal"
                :taiwanLoanTotal="taiwanLoanTotal"
                :foreignLoanTotal="foreignLoanTotal"
                :cashTotal="cashTotal"
                :toBeCredited="bankData.toBeCredited"
            />
        </div>
        <div class="ah-container" v-if="isAuth('D12')" style="margin-bottom: 25px;">
            <el-row :gutter="20" :type="winWidth > 768 ? 'flex' : ''" style="margin-bottom: 25px;">
                <el-col :sm="12">
                    <DepositListCard :title="`台幣存款帳戶餘額`" :isLoading="isLoading" :list="taiwanNormalBanks" :showRat="false" :showEqualTwd="false" :date="date"  />
                </el-col>
                <el-col :sm="12">
                    <DepositListCard :title="`外幣存款帳戶餘額`" :isLoading="isLoading" :list="foreignNormalBanks" totalPrefix="約當" abs :date="date"  />
                </el-col>
            </el-row>
            <el-row :gutter="20" :type="winWidth > 768 ? 'flex' : ''">
                <el-col :sm="12">
                    <DepositListCard :title="`暫存台幣帳戶餘額`" :isLoading="isLoading" :list="taiwanTempBanks" :showRat="false" :showEqualTwd="false" :date="date"  />
                </el-col>
                <el-col :sm="12">
                    <DepositListCard :title="`暫存外幣帳戶餘額`" :isLoading="isLoading" :list="foreignTempBanks" totalPrefix="約當" abs :date="date"  />
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import OverviewPanel from '@/components/dashboard/Finance/Analysis/OverviewPanel.vue';
import DepositSummaryCard from '@/components/dashboard/Finance/Analysis/Deposit/DepositSummaryCard.vue';
import DepositListCard from '@/components/dashboard/Finance/Analysis/Deposit/DepositListCard.vue';

import moment from 'moment';
import IndexOverviewMiddle from './indexOverviewMiddle.vue';

export default {
    name: 'index-analysis-board',
    components: {
        OverviewPanel,
        IndexOverviewMiddle,
        DepositSummaryCard,
        DepositListCard,
    },
    data() {
        return {
            isLoading: false,

            year: new Date().getFullYear(),
            yearList: [],
            overviewData: {
                estimatedEarnings: {},
                monthlyRevenueDatas: {},
                revenue: {
                    invoiceUnTaxAmout: 0,
                    noneInvoiceUnTaxAmount: 0,
                    returnAmount: 0,
                    taxAmount: 0,
                    tranInvoioceUnTaxAmount: 0,
                    unTaxedAmount: 0,
                },
                revenueInfo: {
                    income: 0,
                    netIncome: 0,
                    payout: 0,
                },
                receivableInfo: {
                    accountsReceived: 0,
                    accountsReceivable: 0,
                    accruedReceivables: 0,
                },
                payableInfo: {
                    accountsPayable: 0,
                    accountPaid: 0,
                    accruedPayable: 0,
                },
                salaryInfo: {
                    amount: 0,
                    fixedSalary: 0,
                    nonFixedSalary: 0,
                    bonus: 0,
                    costs: 0,
                },
                variableInfo: {
                    income: 0,
                    payout: 0,
                    feE_BACK_IN: 0,
                },
            },
            bankData: {
                taiwanAccounts: [],
                foreignAccounts: [],
            },

            winWidth: window.innerWidth,
        };
    },
    async mounted() {
        await this.fetchYearOptions();

        const currYear = new Date().getFullYear();
        this.year = currYear;

        this.updateData();

        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    computed: {
        date() {
            const now = new Date();
            if (this.year === now.getFullYear()) {
                return moment(now).format('YYYY-MM-DD');
            }
            return `${this.year}-12-31`;
        },
        allBankData() {
            return this.bankData.taiwanAccounts.concat(this.bankData.foreignAccounts);
        },
        taiwanBanks() {
            return this.bankData.taiwanAccounts.filter((x) => !x.isBorrower).sort((a, b) => b.bal - a.bal);
        },
        taiwanNormalBanks() {
            return this.bankData.taiwanAccounts.filter((x) => !x.isBorrower && x.typ === 0).sort((a, b) => b.bal - a.bal);
        },
        taiwanTempBanks() {
            return this.bankData.taiwanAccounts.filter((x) => !x.isBorrower && x.typ === 1).sort((a, b) => b.bal - a.bal);
        },
        foreignBanks() {
            return this.bankData.foreignAccounts.filter((x) => !x.isBorrower).sort((a, b) => b.bal - a.bal);
        },
        foreignNormalBanks() {
            return this.bankData.foreignAccounts.filter((x) => !x.isBorrower && x.typ === 0).sort((a, b) => b.bal - a.bal);
        },
        foreignTempBanks() {
            return this.bankData.foreignAccounts.filter((x) => !x.isBorrower && x.typ === 1).sort((a, b) => b.bal - a.bal);
        },
        taiwanLoans() {
            return this.bankData.taiwanAccounts.filter((x) => x.isBorrower).sort((a, b) => b.bal - a.bal);
        },
        foreignLoans() {
            return this.bankData.foreignAccounts.filter((x) => x.isBorrower).sort((a, b) => b.bal - a.bal);
        },
        taiwanDepositTotal() {
            const accounts = this.taiwanBanks.map((x) => x.bal);
            if (accounts.length === 0) return 0;
            return accounts.reduce((a, b) => a + b);
        },
        foreignDepositTotal() {
            const accounts = this.foreignBanks.map((x) => x.bal * x.rat);
            if (accounts.length === 0) return 0;
            return Math.round(accounts.reduce((a, b) => a + b));
        },
        taiwanLoanTotal() {
            const accounts = this.taiwanLoans.map((x) => x.bal);
            if (accounts.length === 0) return 0;
            return accounts.reduce((a, b) => a + b);
        },
        foreignLoanTotal() {
            const accounts = this.foreignLoans.map((x) => x.bal * x.rat);
            if (accounts.length === 0) return 0;
            return Math.round(accounts.reduce((a, b) => a + b));
        },
        loanTotal() {
            return this.taiwanLoanTotal + this.foreignLoanTotal;
        },
        cashTotal() {
            return this.bankData.cash;
        },
    },
    methods: {
        async updateData() {
            try {
                this.isLoading = true;
                const result = await this.$api({
                    url: `HomePage/GetPageInfo?Year=${this.year}`,
                    method: 'GET',
                });

                this.updateBankData(result.data.depositOverviewInfo);
                this.updateOverviewData(result.data.overviewInfo);
                this.$refs.IndexOverviewMiddle.updateIncomeData(result.data.incomeAnalysisInfo);
                this.$refs.IndexOverviewMiddle.updatePayoutData(result.data.payoutAnalysisInfo);
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        updateOverviewData(data) {
            this.overviewData = data;

            // 長條圖
            const today = new Date();
            const thisMonth = today.getMonth() + 1;
            const thisYear = today.getFullYear();

            const seriesData = {
                income: [],
                payout: [],
                netIncome: [],
                monthlyDeposit: [],
                monthlyLoan: [],
                creditNoteNoTax: [],
            };

            data.monthlyRevenue.forEach((item) => {
                if (this.year >= thisYear && item.month > thisMonth) {
                    if (item.income > 0 || item.payout > 0) {
                        seriesData.income.push(item.income);
                        seriesData.payout.push(item.payout);
                        seriesData.netIncome.push(item.netIncome);
                        seriesData.creditNoteNoTax.push(item.creditNoteNoTax);
                        if (this.isAuth('D13')) {
                            seriesData.monthlyDeposit.push(item.monthlyDeposit);
                            seriesData.monthlyLoan.push(Math.abs(item.monthlyLoan));
                        }
                    }
                } else {
                    seriesData.income.push(item.income);
                    seriesData.payout.push(item.payout);
                    seriesData.netIncome.push(item.netIncome);
                    seriesData.creditNoteNoTax.push(item.creditNoteNoTax);
                    if (this.isAuth('D13')) {
                        seriesData.monthlyDeposit.push(item.monthlyDeposit);
                        seriesData.monthlyLoan.push(Math.abs(item.monthlyLoan));
                    }
                }
            });

            this.overviewData.monthlyRevenueDatas = seriesData;
        },
        updateBankData(data) {
            this.bankData = data;
        },
        async fetchYearOptions() {
            const resp = await this.$api({
                url: 'FinancialAnalysisPage/GetOverviewYearOptions',
                method: 'GET',
            });
            this.yearList = resp.data.options;

            if (resp.data.options && resp.data.options.length > 0) {
                this.yearList = resp.data.options;
            } else {
                this.yearList = [new Date().getFullYear()];
            }

            this.yearList.sort((a, b) => b - a);
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        onResize() {
            this.winWidth = window.innerWidth;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.index-overviews {
    .section-title {
        font-size: 11.5pt;
        font-weight: bold;
        color: #555;
        margin-bottom: -12px;
    }
}
</style>
